// Pack-Card — kompakte Einmalkauf-Karte in der /credits-Pack-Sektion.
// Bewusst leichter/sekundär gestylt (gedämpft, kein Glow) gegenüber Abo-Karten.

import { motion } from 'framer-motion';
import { Loader2 } from 'lucide-react';
import { formatPriceEur, type CreditPack } from '@/lib/credits-api';

interface PackCardProps {
  pack: CreditPack;
  inFlight: boolean;
  disabled: boolean;
  index: number;
  onBuy: (packId: string) => void;
}

export function PackCard({ pack, inFlight, disabled, index, onBuy }: PackCardProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.2 + index * 0.05, type: 'spring', stiffness: 260, damping: 26 }}
      className="flex flex-col rounded-2xl border border-slate-800 bg-slate-900/40 p-4 transition-colors hover:border-slate-700"
    >
      <p className="text-[13px] font-semibold text-slate-200">
        <span className="text-amber-400/70">◆</span> {pack.label}
      </p>
      <p className="mt-0.5 text-[12px] text-slate-500">
        +{pack.credits.toLocaleString('de-DE')} Credits
      </p>
      <div className="mt-3 mb-4">
        <span className="text-2xl font-bold text-white">{formatPriceEur(pack.price_cents)}</span>
      </div>
      <button
        type="button"
        onClick={() => onBuy(pack.id)}
        disabled={disabled}
        className="mt-auto inline-flex w-full items-center justify-center gap-1.5 rounded-lg border border-slate-700 px-3 py-2 text-[12px] font-semibold text-slate-300 transition-colors hover:border-slate-500 hover:text-white disabled:cursor-not-allowed disabled:opacity-40"
      >
        {inFlight ? <Loader2 className="size-3.5 animate-spin" /> : null}
        Kaufen
      </button>
    </motion.div>
  );
}
